import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';

import { Auth } from '../support';
import Storage from '../support/Storage';
import Loading from '../facturotopia/loading/Loading';

class Bridge extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      restored: false,
      hint: 'Recuperando información de sesión'
    }
  }

  async componentDidMount() {
    let isAccountSuspended = false;

    if (!Auth.isAuthenticated()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isAccountSuspended = data.cliente.status === -1 || data.cliente.status === -2;
      }
    }

    this.setState({
      restored: true,
      isAccountSuspended: isAccountSuspended
    });
  }

  render() {
    const { restored, isAccountSuspended } = this.state;

    if (isAccountSuspended) {
      const original = Auth.getData();

      const { override } = original || {};

      if (!override) {
        return <Redirect to="/suspended" />;
      }
    }

    if (restored) {
      const { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };
      const redirectTo = {
        pathname: Auth.isAuthenticated() ? from.pathname : '/auth/login',
        search: from.search,
        state: from.state
      }

      return <Redirect to={ redirectTo } state={ from }/>;
    }

    return (
      <div className="row">
        <div className="col">
          <div className="px-4 py-3">
            <Loading />
          </div>
        </div>
      </div>
    );
  }
}

export default Bridge;